import * as $ from 'jquery';
import portalConfirm from './portal-confirm';
import TrainerSelect from './select-trainer';
import LocationSelect from './select-location';

var SessionsTable = function ($table) {
    this.$table = $table;
    this.$tbody = $table.find('tbody');
    this.$submit = this.$table.find('button.add-session');
    this.setup();
};

SessionsTable.prototype.setup = function()
{
    this.$table.on('click', 'i.fa.fa-trash-o', $.proxy(this.deleteRow, this));
    this.$table.on('click', 'i.fa.fa-copy', $.proxy(this.copyRow, this));
    this.$submit.on('click', $.proxy(this.addRow, this));
};

SessionsTable.prototype.refresh = function()
{
    this.$tbody.find('tr > td:first-child').each(function(idx) {
        $(this).html('Day ' + (idx + 1));
    });
};

SessionsTable.prototype.deleteRow = function(e)
{
    var $this = $(e.target);
    if (portalConfirm('Are you sure you want to delete this row?') !== false)
    {
        $this.closest('tr').remove();
        this.refresh();
    }
};

SessionsTable.prototype.addRow = function(e, values)
{
    var today = new Date();
    var date_today = today.getFullYear() + '-' + (today.getMonth()+1) + '-' + today.getDate() + ' 9:00';

    var data = $.extend({
        date_start: date_today,
        time_end: '17:00',
        trainer_id: null,
        co_trainer_id: null,
        location_id: $("#fluffy_control_location").val(),
        custom_address: $('input[name="custom_address"]').val()
    }, values);

    e.preventDefault();
    var $tr = $('<tr/>');
    $tr.append( $('<td/>', { class: 'align-middle' }) );
    $tr.append( this.$dateStart(data.date_start) );
    $tr.append( this.$timeEnd(data.time_end) );
    $tr.append( this.$trainer('trainer_id', 'Trainer', data.trainer_id) );
    $tr.append( this.$trainer('co_trainer_id', 'Co-trainer', data.co_trainer_id) );

    if($('input[name="type"]').val() === "incompany") {
        $tr.append( this.$custom_address(data.custom_address) );
    } else {
        $tr.append( this.$location(data.location_id) );
    }
    $tr.append( this.$controls() );
    this.$tbody.append($tr);

    // Setup the day number
    this.refresh();
};

SessionsTable.prototype.copyRow = function(e)
{
    var $this = $(e.target);
    if (portalConfirm('Are you sure you want to copy this row?') !== false)
    {
        var $tr = $this.closest('tr');
        var current_date = $tr.find('[name*=date_start]').val();
        var time = current_date.split(" ").splice(-1)[0];
        var date = new Date(current_date.replace(/-/g, "/"));

        date.setDate( date.getDate() + 1 );
        var date_today = date.getFullYear() + '-' + (date.getMonth()+1) + '-' + date.getDate() + ' ' + time;

        var data = {
            date_start: date_today,
            time_end: $tr.find('[name*=date_end]').val(),
            trainer_id: $tr.find('[name$="[trainer_id]"]').val(),
            co_trainer_id: $tr.find('[name$="[co_trainer_id]"]').val(),
            location_id: $tr.find('[name*=location_id]').val(),
            custom_address: $tr.find('[name*=custom_address]').val()
        };
        this.addRow(e, data);
    }
};

SessionsTable.prototype.$dateStart = function(value)
{
    var inputName = 'sessions['+ (this.$tbody.find('tr').length) +'][date_start]';

    var $td = $('<td/>');
    var $label = $('<label/>', {
        for: inputName
    }).html('Start');

    var $input = $('<input/>', {
        name: inputName,
        id: inputName,
        type: 'text',
        class: 'form-control date-time',
        autocomplete: 'off'
    });

    if (value) $input.val(value);

    $input.datetimepicker({
        format:'Y-m-d H:i'
    }).attr('autocomplete', "off");

    $td.append($label);
    $td.append($input);

    return $td;
};

SessionsTable.prototype.$timeEnd = function(value)
{
    var inputName = 'sessions['+ (this.$tbody.find('tr').length) +'][date_end]';

    var $td = $('<td/>');
    var $label = $('<label/>', {
        for: inputName
    }).html('End');

    var $input = $('<input/>', {
        name: inputName,
        id: inputName,
        type: 'text',
        class: 'form-control time',
        autocomplete: 'off'
    });

    if (value) $input.val(value);

    $input.datetimepicker({
        datepicker: false,
        format:'H:i'
    }).attr('autocomplete', "off");

    $td.append($label);
    $td.append($input);

    return $td;
};

SessionsTable.prototype.$trainer = function(name, label, value)
{
    var inputName = 'sessions['+ (this.$tbody.find('tr').length) +']['+name+']';

    var $td = $('<td/>');
    var $label = $('<label/>', {
        for: inputName
    }).html(label);

    var $select = $('<select/>', {
        name: inputName,
        id: inputName,
        class: 'form-control selectpicker show-tick',
        autocomplete: 'off'
    });

    var $container = $('<div>', {class: 'form-group'});
    $container.append($label);
    $container.append($select);

    setTimeout(function() {
        var trainerSelectInstance = new TrainerSelect($select, value);
        trainerSelectInstance.create();
    }, 10);

    $td.append($container);

    return $td;
};
SessionsTable.prototype.$custom_address = function(value)
{
    var inputName = 'sessions['+ (this.$tbody.find('tr').length) +'][custom_address]';

    var $td = $('<td/>');
    var $label = $('<label/>', {
        for: inputName
    }).html('Location');

    var $inputText = $('<input/>', {
        type: "text",
        name: inputName,
        value: value,
        id: inputName,
        class: 'form-control selectpicker show-tick',
        autocomplete: 'off'
    });


    var $container = $('<div>', {class: 'form-group'});
    $container.append($label);
    $container.append($inputText);

    $td.append($container);

    return $td;
};

SessionsTable.prototype.$location = function(value)
{
    var inputName = 'sessions['+ (this.$tbody.find('tr').length) +'][location_id]';

    var $td = $('<td/>');
    var $label = $('<label/>', {
        for: inputName
    }).html('Location');

    var $select = $('<select/>', {
        name: inputName,
        id: inputName,
        class: 'form-control selectpicker show-tick',
        autocomplete: 'off'
    });


    var $container = $('<div>', {class: 'form-group'});
    $container.append($label);
    $container.append($select);

    setTimeout(function() {
        var locationSelectInstance = new LocationSelect($select, value);
        locationSelectInstance.create();
    }, 10);

    $td.append($container);

    return $td;
};

SessionsTable.prototype.$controls = function()
{
    var $td = $('<td/>', { class: 'align-middle' });
    $td.append( $('<i/>', { class: 'fa fa-trash-o' }) );
    $td.append('&nbsp;');
    $td.append( $('<i/>', { class: 'fa fa-copy' }) );
    return $td;
};

export default SessionsTable;
